import { useIsFetching } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { PRICING_RULES_BASE_QUERY_KEY } from 'components/domain/propertyPricing/pricingRulesQuery';
import SectionHeader from 'pages/property/common/SectionHeader';
import PermissionsAwareFieldset from '../../../common/PermissionsAwareFieldset';
import PriceRulesOverrideAirbnb from './PriceRulesOverrideAirbnb';
import PriceRulesTable from './PriceRulesTable';
import usePriceRulesAddEditModal from './modals/usePriceRulesAddEditModal';

const PriceRules = () => {
  const { t } = useTranslation();
  const { openAddPriceRulesModal } = usePriceRulesAddEditModal();
  const amountOfPriceRulesQueries = useIsFetching({
    queryKey: [PRICING_RULES_BASE_QUERY_KEY],
  });
  const isFetchingPriceRules = amountOfPriceRulesQueries > 0;

  return (
    <section data-testid="price-rules-section">
      <PermissionsAwareFieldset>
        <SectionHeader
          id="price-rules-header"
          title={t('pageProperty.pricing.priceRules.title')}
          button={{
            disabled: isFetchingPriceRules,
            label: t('pageProperty.pricing.priceRules.addPriceRule'),
            onClick: openAddPriceRulesModal,
          }}
          tooltip={t('pageProperty.pricing.priceRules.tooltip')}
        />
        <PriceRulesOverrideAirbnb />
        <PriceRulesTable />
      </PermissionsAwareFieldset>
    </section>
  );
};

export default PriceRules;
